import {EmployeeAddress} from "./employee";

export class PayeeAddress extends EmployeeAddress {
  timesheetWorkLocationType: string;
}